import { createContext } from "react";

const UserContext = createContext({
  user: null,
  tokens: {},
});

export default UserContext;
